import { render } from "./PhotoUpload.vue?vue&type=template&id=131085c8&ts=true"
import script from "./PhotoUpload.vue?vue&type=script&lang=ts"
export * from "./PhotoUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__